<template>
  <div class="whiteBg vh100" style="min-width:315px">
    <div class="wxtip" v-show="isShow" @click.self="isShow = false">
      <span class="wxtip-icon"></span>
    </div>
    <van-tabs
      class="downloadTabs"
      color="#ff6600"
      sticky
      title-active-color="#ff6600"
    >
      <van-tab
        title-style="font-size:16px"
        v-for="(tab, i) in tabs"
        :key="i"
        :title="tab"
      >
        <div
          class="item flex"
          v-for="(item, index) in i === 1 ? bossApp : courierApp"
          :key="index"
          :style="
            index === (i === 1 ? bossApp : courierApp).length - 1
              ? 'border:none'
              : ''
          "
        >
          <van-image
            class="logo"
            width="60"
            height="60"
            :src="item.logo"
          ></van-image>
          <!-- <img class="logo" :src="item.logo" width="60" height="60" alt="" /> -->
          <div class="info">
            <div class="title">
              <span>{{ item.name }}</span>
              <div class="recommend" v-if="item.recommend">
                推荐
                <span />
              </div>
            </div>
            <div>{{ item.content }}</div>
            <div>
              版本：{{
                isiOS && item.iosVersion ? item.iosVersion : item.version
              }}
            </div>
            <div v-if="isiOS && item.iosLink === ''">
              目前仅支持安卓系统
            </div>
          </div>
          <van-button
            class="download"
            plain
            round
            color="#ff6600"
            :disabled="isiOS && item.iosLink === ''"
            @click="download(item)"
            v-if="!item.copy && !isMini"
            >下载</van-button
          >
          <van-button
            class="download"
            plain
            round
            color="#ff6600"
            v-else-if="item.copy"
            @click="copy(item)"
            >复制</van-button
          >
        </div>
      </van-tab>
    </van-tabs>
    <div class="guide" @click="guide" v-if="isMini">如何下载APP？</div>
    <van-popup v-model="show" position="bottom" :style="{ height: '90%' }">
      <div class="popup_content">
        <img :src="require('@/../static/app.jpg')" alt="" class="app" />
      </div>
    </van-popup>
  </div>
</template>

<script>
import axios from 'axios'
// import { bossApp, courierApp } from './url'
export default {
  data() {
    return {
      isWeixin: false,
      isiOS: false,
      isShow: false, // 引导浏览器打开弹窗
      bossApp: [],
      courierApp: [],
      tabs: ['我是快递员', '我是驿站'],
      isMini: false,
      show: false // 如何下载app弹窗
    }
  },
  created() {
    let url = `/url.json?v=${new Date().getTime()}`;
    axios.get(url).then(res => {
      this.bossApp = res.data.bossApp
      this.courierApp = res.data.courierApp
    })
    if (this.$route.query.type === 'mini') {
      this.isMini = true
    }
    var u = navigator.userAgent
    let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // ios终端 修复iOS版微信HTML5 History兼容性问题
    if (isiOS) {
      // 苹果手机
      this.isiOS = true
    } else {
      // 安卓手机
    }
    var ua = navigator.userAgent
    var isWeixin = !!/MicroMessenger/i.test(ua)
    this.isWeixin = isWeixin
  },
  mounted() {},
  methods: {
    weixinTip() {
      console.log(this.isWeixin)
      this.isShow = this.isWeixin
    },
    download(item) {
      /* eslint-disable camelcase */

      if (item.iosLink !== '' && this.isiOS) {
        // 打开苹果商店
        this.clickLink(item.iosLink)
      } else {
        if (this.isWeixin) {
          this.weixinTip()
        } else {
          // 下载apk
          let url = `${item.androidLink}?t=${new Date().getTime()}`;
          this.clickLink(url)
        }
      }
    },
    clickLink(url) {
      let link = document.createElement('a')
      link.style.display = 'none'
      link.href = url
      document.body.appendChild(link)
      link.click()

      setTimeout(() => {
        document.body.removeChild(link)
      }, 20000)
    },
    copy(item) {
      let value = item.androidLink
      var input = document.createElement('input')
      input.value = value
      input.setAttribute('readonly', 'readonly')
      document.body.appendChild(input)
      input.select()
      document.execCommand('Copy')
      this.$toast({
        position: 'bottom',
        message: '已复制下载链接'
      })
      document.body.removeChild(input)
    },
    guide() {
      this.show = true
    }
  }
}
</script>
<style lang="scss">
.downloadTabs::-webkit-scrollbar {
  display: none;
}
.downloadTabs {
  height: calc(100vh - 2rem - env(safe-area-inset-bottom));
  overflow: auto;
  .van-sticky {
    background: #fff;
  }
  .van-tabs__wrap {
    width: 250px;
  }
  .item {
    padding: 5px 10px;
    background-color: #fff;
    border-bottom: 1px solid #f1f1f1;
  }
  .logo {
    margin: 10px;
    box-shadow: 1px 1px 5px #dddddd;
    // background: #000;
    border-radius: 15px;
  }
  .info {
    flex: 1;
    div {
      margin: 3px 0;
      font-size: 12px;
      color: #a3a3a3;
      span {
        font-size: 15px;
        color: #000;
      }
    }
    .title {
      display: flex;
      align-items: center;
      .recommend {
        position: relative;
        padding: 0 3px;
        margin-left: 10px;
        color: #fff;
        font-size: 12px;
        background-color: red;
        border-radius: 3px;
        span {
          display: block;
          position: absolute;
          top: 50%;
          left: -8px;
          transform: translateY(-50%);
          border: 4px solid red;
          border-top: 4px solid transparent;
          border-left: 4px solid transparent;
          border-bottom: 4px solid transparent;
        }
      }
    }
  }
  .download {
    height: 30px;
  }
}
.wxtip {
  background: rgba(0, 0, 0, 0.8);
  text-align: center;
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 998;
}
.wxtip-icon {
  width: 161px;
  height: 100px;
  background: url('../../../static/cue.png') no-repeat;
  background-size: contain;
  display: block;
  position: absolute;
  right: 5px;
  top: 0px;
}
.wxtip-txt {
  margin-top: 107px;
  color: #fff;
  font-size: 16px;
  line-height: 1.5;
}
.guide {
  font-size: 14px;
  padding: 0.3rem;
  text-align: center;
  color: #ff6600;
}
.popup_content {
  // padding: 1.6875rem 1.875rem;
  .app {
    width: 100%;
    height: 100%;
  }
}
</style>
